let audioContext = null;          // singleton AudioContext
let isUnlocked = false;          // true after first user gesture
let hasEverResumed = false;      // true after first successful resume

/** Unlock + create AudioContext – must be called from a user gesture */
export const unlockAudio = async () => {
    if (isUnlocked && audioContext?.state === 'running') return true;

    try {
        // Create once
        if (!audioContext) {
            const Ctor = window.AudioContext || window.webkitAudioContext;
            audioContext = new Ctor();
        }

        await audioContext.resume();

        // iOS needs a real sound to “lock-in” the pipeline
        const osc = audioContext.createOscillator();
        const gain = audioContext.createGain();
        gain.gain.value = 0.0001;               // inaudible
        osc.connect(gain);
        gain.connect(audioContext.destination);
        osc.start();
        osc.stop(audioContext.currentTime + 0.001);

        isUnlocked = true;
        console.log('Audio unlocked (first gesture)');
        return true;
    } catch (e) {
        console.log('unlockAudio failed', e);
        return false;
    }
};
/** Resume after background – safe to call without gesture */
export const tryAutoResume = async () => {
    if (!audioContext) return false;
    if (audioContext.state === 'running') return true;

    try {
        await audioContext.resume();
        hasEverResumed = true;
        console.log('AudioContext auto-resumed');
        return true;
    } catch (e) {
        console.warn('auto-resume failed (needs gesture)', e);
        return false;
    }
};
/** Public – call from SignalR / anywhere */
export const playAudio = async (path) => {
    if (!isUnlocked || !audioContext) {
        console.log('playAudio: not unlocked yet');
        return false;
    }

    // Try cheap resume first (works after first successful resume)
    if (!hasEverResumed) await tryAutoResume();

    if (audioContext.state !== 'running') {
        console.warn('playAudio: context suspended – user must tap');
        return false;
    }

    try {
        const resp = await fetch(path);
        const buf = await resp.arrayBuffer();
        const audioBuf = await audioContext.decodeAudioData(buf);

        const src = audioContext.createBufferSource();
        src.buffer = audioBuf;
        src.connect(audioContext.destination);
        src.start(0);
        return true;
    } catch (e) {
        console.log('playAudio error', e);
        return false;
    }
};

export { audioContext }
export const isAudioReady = () => isUnlocked && audioContext?.state === 'running';